import { render, staticRenderFns } from "./Notifier.vue?vue&type=template&id=42c45b73"
import script from "./Notifier.vue?vue&type=script&lang=js"
export * from "./Notifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports